<div class="container">


  <div class="big-box">
    <div class="instruction-box">
      <p>Please select the next state of the Application & Submit for the below user</p>
      <div class="user-details">
        <p>  <span>{{ solarRequestData?.first_name }}, {{ solarRequestData?.phone_number }}</span>
          <span class="location">{{ solarRequestData?.locality }}, {{ solarRequestData?.state_name }}</span></p>
        
      </div>
      <div class="reset-btn">
        <button (click)="openPopup('reset')">Reset</button>
      </div>
    </div>

    <div class="progress-container">
      <ng-container *ngFor="let state of applicationStates; let last = last">
        <div class="progress-step" [ngClass]="{
          'next-action': canUpdate(state.status),
          'selected': isStateSelected(state.id),
          'done':state.status == 'Done'
        }"
        (click)="canUpdate(state.status) && toggleStateSelection(state.id)">
          <div class="step-circle">{{state.state}}</div>
          <img *ngIf="!last" src="assets/arrow.png" class="arrow" alt="arrow">
        </div>
      </ng-container>
    </div>

    <div class="submit-btn">
      <button [disabled]="!selectedStateId" (click)="selectedStateId && openPopup('update')" >SUBMIT</button>
    </div>
  </div>


    <!--Confirm update Popup --> 
    <div *ngIf="showPopup" class="popup-overlay">
      <div class="popup-content">
        <p class="cancel"><span  (click)="closePopup()" >x</span></p>
        <div class="popup-body">
          <ng-container *ngIf="popupType === 'reset'">
            <h3>Are you sure to reset the state of Application?</h3>
          </ng-container>
          <ng-container *ngIf="popupType === 'update'">
            <h3>Are you sure to update the state of Application?</h3>
            <div class="step-circle">
              {{selectedStateName}}
            </div>
          </ng-container>
          <button  class="yes-button"  (click)="onConfirm()">YES</button>
        </div>
      </div>
    </div>

</div>



 